import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div
        className="flex h-screen items-center justify-center bg-background"
        data-testid="protected-loading"
      >
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-navy-600 border-t-transparent" />
          <span className="text-xs uppercase tracking-widest text-slate-500">
            Honey Badger
          </span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div
          className="max-w-md rounded-md border border-slate-200 bg-white p-8 text-center shadow-sm"
          data-testid="access-denied"
        >
          <div className="mb-2 text-xs font-semibold uppercase tracking-widest text-brand-orange">
            403 · Forbidden
          </div>
          <h2 className="text-xl font-semibold text-navy-600">Access restricted</h2>
          <p className="mt-2 text-sm text-slate-500">
            Your current role ({user.role}) cannot view this page. Contact a
            SUPER_ADMIN to adjust your permissions.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
